import { getResponseQuery } from "@helpers/_functions";

import http from "../../http-common";
import BaseService from "../base.service";

class SurveyQuestionService extends BaseService {
  constructor() {
    super("survey-questions");
  }

  updateMany(surveyQuestions) {
    return getResponseQuery(
      http.post(`${this.path}/update-many`, surveyQuestions)
    );
  }
}

export default new SurveyQuestionService();
